module.exports = __webpack_public_path__ + "media/images/25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/25.jpg
// module id = 62
// module chunks = 0